module.exports = __webpack_public_path__ + "img/image-qr-code.a7ee477d.png";